import { Icon } from "@/lib/icons/Icon";
import styles from "./ImagePlaceholder.module.css";

/**
 * Fallback dla braku obrazka - wyświetla wycentrowaną ikonę zdjęcia.
 * Size-agnostic: wypełnia rodzica (thumb, grid tile, hero cover), rozmiar
 * dyktuje wrapper. Bez tła własnego - dziedziczy z rodzica.
 */
export function ImagePlaceholder() {
  return (
    <span className={styles.root}>
      <Icon name="image" className={styles.icon} />
    </span>
  );
}
